import { INTERNAL_USER_AGENTS, vars } from '@repo/config';

export function createAuthRequestHeaders(cookieHeader: string): Record<string, string> {
  return {
    origin: vars.url.webUrl,
    cookie: cookieHeader,
    'user-agent': INTERNAL_USER_AGENTS.authIdentity,
  };
}
